// Highmaps options
const mapTooltipOptions = {
  animation: true,
  backgroundColor: "transparent",
  borderWidth: 0,
  formatter: function() {
    return `
      <div style="box-shadow: 0 0 4px 1px rgba(0, 0, 0, 0.3);">
        <div style="background-color: white; padding: 10px; border-top: 8px solid ${this.color}">
        <b>${this.key}</b></br>
        </div>
      </div>
    `;
  },
  hideDelay: 100,
  shadow: false,
  shape: "square",
  style: { color: "black", padding: 0 },
  useHTML: true,
};

const defaultMapOptions = {
  chart: {
    height: 600,
    width: 500,
    style: {
      fontFamily: "'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif"
    },
    spacingTop: 5,
    spacingBottom: 0,
    spacingLeft: -50,
    spacingRight: -50,
    animation: {
      duration: 50
    }
  },
  credits: {
    enabled: false,
  },
  exporting: {
    enabled: false
  },
  title: {
    text: ""
  },
  tooltip: mapTooltipOptions
};

const tariffMapColorAxis = [{
  from: 0,
  to: 0.5,
  color: "#d5e49f",
  "name": "<$0.50/m3"
}, {
  from: 0.5,
  to: 0.99,
  color: "#aed367",
  "name": "$0.50-0.99/m3"
}, {
  from: 1.0,
  to: 1.99,
  color: "#4cb563",
  "name": "$1.00-1.99/m3"
}, {
  from: 2.0,
  to: 100,
  color: "#4a7f53",
  "name": ">$2.00/m3"
}];

export { defaultMapOptions, tariffMapColorAxis };
